export default __webpack_public_path__ + "static/media/1.fcd46e80.jpg";